import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {StepRegisterPage} from "./pages/session/StepRegisterPage";
import {Route, RouteComponentProps} from "react-router";
import {Footer} from "./partials/Footer";
import {GuestHeader} from "./partials/GuestHeader";

interface StRegisterLayoutProps extends RouteComponentProps<any> {
}

@observer export class StRegisterLayout extends Component<StRegisterLayoutProps, any> {

    render() {
        const { match } = this.props;

        return <div className={'profile-layout st-layout'}>
            <GuestHeader {...this.props} noRegisterButton />

            <Route path={`${match.path}/register`} component={StepRegisterPage} />

            <Footer />
        </div>
    }

}
